import designSystemStyles from '@shared/styles/designSystemStyles';
import { isMobile, isMobileOnly } from 'react-device-detect';

interface TitleProps {
    text: string;
    className?: string;
}

export const H1Title: React.FC<TitleProps> = ({ 
		text, 
        className
	}) => {

    return (
        <h1
            className={['DSH1Title', className].filter(Boolean).join(' ')}
            style={{ color: designSystemStyles.colorTitleText }}
        >
            {text}
        </h1>
    );
};

export const H2Title: React.FC<TitleProps> = ({ 
		text, 
        className
	}) => {

    return (
        <h2
            className={['DSH2Title', className].filter(Boolean).join(' ')}
            style={{ color: designSystemStyles.colorTitleText }}
        >
            {text}
        </h2>
    );
};

export const H3Title: React.FC<TitleProps> = ({ 
		text, 
        className
	}) => {

    return (
        <h3
            className={['DSH3Title', className].filter(Boolean).join(' ')}
            style={{ color: designSystemStyles.colorTitleText }}
        >
            {text}
        </h3>
    );
};


export const Subtitle: React.FC<TitleProps> = ({ 
		text, 
        className
	}) => {

	return (
        <p className={['DSSubtitle', className].filter(Boolean).join(' ')} style={{
            fontSize: isMobileOnly ? designSystemStyles.fontSizeSm : designSystemStyles.fontSizeMd,
            color: designSystemStyles.colorTextSecondary,
            marginTop: 0,
            fontWeight: designSystemStyles.fontWeightWarning,
            lineHeight: 1.4
        }}>
            {text}
        </p>
	);
};
